//imports
import { all } from 'redux-saga/effects';

//Views
import deleteScheduledActionSagas from 'Modules/scheduledActions/views/components/deleteScheduledAction/redux/saga';
import createEditScheduledActionSagas from 'Modules/scheduledActions/views/components/editScheduledAction/redux/saga';
//merge sagas
export default function* rootSaga() {
    yield all([
        deleteScheduledActionSagas(),
        createEditScheduledActionSagas(),
    ]);
}